import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getRplWorkshop = 'sertifikasi-rpl';
const getDetailRplWorkshop = 'sertifikasi-rpl/';
const postRplWorkshopUrl = 'sertifikasi-rpl';
const putRplWorkshop = 'sertifikasi-rpl/';
const deleteDokumen = 'sertifikasi-rpl/delete-dokumen-sertifikasi-rpl/'
const deleteRplWorkshop = 'sertifikasi-rpl/delete-sertifikasi-rpl/';
const deleteMataUji = 'sertifikasi-rpl/delete-sertifikasi-rpl-mata-uji/';
const deleteInstruktur = 'sertifikasi-rpl/delete-instruktur-sertifikasi-rpl/'
const getDataPeserta = 'sertifikasi-rpl/peserta';
const getDetailMataUjiPeserta = 'sertifikasi-rpl/data-peserta/get-data-mata-uji/'
const absenPeserta = 'sertifikasi-rpl/data-peserta/absensi-peserta/'
const getDokumenRplPeserta = 'jadwal-test-center/dokumen-pendukung-peserta-rpl';
const verifikasiDokumen = 'jadwal-test-center/data-peserta/verifikasi-dokumen-pendukung-one-unit/';
class RplWorkshopService {
    getRplWorkshop(currentPage,pageSize,filter) {
        return axios.get(
            API_URL + getRplWorkshop + '?pageNo=' + currentPage + '&pageSize=' +  pageSize  + '&filter=' + filter + '&kategoriRpl=ACPA',
        {
            headers: authHeader()
        });
    }

    verifikasiDokumenPeserta(formData) {
        return axios.put(
            API_URL + verifikasiDokumen + formData.idDokumenPendukungRpl ,
            formData,
            { headers: { 'Content-Type': 'application/json','Authorization' : tokenHeader() } });
    }

    getDokumenRplPeserta(id_sertifikasi_rpl_peserta) {
        return axios.get(
            API_URL + getDokumenRplPeserta + '?idSertifikasiRplPeserta='+ id_sertifikasi_rpl_peserta,
        {
            headers: authHeader()
        });
        
    }

    absenPeserta(formData) {
        return axios.put(
            API_URL + absenPeserta + formData.idSertifikasiRplPeserta,
            formData,
            { headers: authHeader() }
        );
    }

    getDataPeserta(currentPage,pageSize,filter,idSertifikasiRpl) {
        return axios.get(
            API_URL + getDataPeserta + '?pageNo=' + currentPage + '&pageSize=' +  pageSize  + '&filter=' + filter +'&id_sertifikasi_rpl='+idSertifikasiRpl,
            {
                headers: authHeader()
            });
    }

    getDetailMataUjiPeserta(id_sertifikasi_rpl_peserta) {
        return axios.get(
            API_URL + getDetailMataUjiPeserta + id_sertifikasi_rpl_peserta ,
            {
                headers: authHeader()
            });
    }

    getDetailRplWorkshop(idSertifikasiRpl) {
        return axios.get(
            API_URL + getDetailRplWorkshop + idSertifikasiRpl,
            {
                headers: authHeader()
            });
    }

    postRplWorkshop(formData) {
        
        return axios
            .post(
                API_URL + postRplWorkshopUrl,
                formData,
                {
                    headers: authHeader()
                }
            );
    }

    putRplWorkshop(formData) {
        return axios
            .put(
                API_URL + putRplWorkshop + formData.idSertifikasiRpl,
                formData,
                {
                    headers: authHeader()
                }
            );
    }

    putRplWorkshopBackup(formData) {
        var form = new FormData();
        form.append("kodeRpl", formData.kodeRpl);
        form.append("namaRpl", formData.namaRpl);
        form.append("idLevel", formData.idLevelAnggota);
        form.append("biaya", formData.hargaPendaftaran);
        form.append("biayaMengulang", formData.biayaMengulang);
        form.append("tanggalDimulai", formData.tanggalDimulai);
        form.append("tanggalBerakhir", formData.tanggalBerakhir);
        form.append("lokasi", formData.lokasi);
        form.append("idKotaKab", formData.idKotaKab);
        form.append("kapasitas", formData.kapasitas);
        form.append("sisa", formData.kapasitas);
        form.append("idKategoriRpl", "1bc7e9ee-b8b8-4c5a-972c-7fa0ecb75f6f");
        for (var i = 0; i < formData.instrukturSertifikasiRpl.length; i++) {
            form.append('instrukturSertifikasiRplRequest['+i+'].idInstrukturRpl', formData.instrukturSertifikasiRpl[i].idInstrukturRpl);
            form.append('instrukturSertifikasiRplRequest['+i+'].idRplSertifikasiRplInstruktur', formData.instrukturSertifikasiRpl[i].idInstrukturSertifikasiRpl);
        }
        for (var j = 0; j < formData.dokumenPendukungSertifikasiRpl.length; j++) {
            form.append('dokumenPendukungSertifikasiRplRequest['+j+'].kodeDokumen', formData.dokumenPendukungSertifikasiRpl[j].kodeDokumen);
            form.append('dokumenPendukungSertifikasiRplRequest['+j+'].namaDokumen', formData.dokumenPendukungSertifikasiRpl[j].namaDokumen);
            form.append('dokumenPendukungSertifikasiRplRequest['+j+'].idDokumenPendukungSertifikasiRpl', formData.dokumenPendukungSertifikasiRpl[j].idDokumenPendukungSertifikasiRpl);
            if (typeof formData.dokumenPendukungSertifikasiRpl[j].contohDokumen !== 'undefined') {
                form.append('dokumenPendukungSertifikasiRplRequest['+j+'].contohDokumen', formData.dokumenPendukungSertifikasiRpl[j].contohDokumen);
            }
        }
        for (var k = 0; k < formData.sertifikasiRplMataUji.length; k++) {
            form.append('sertifikasiRplMataUjiRequest['+k+'].idMasterMataUji', formData.sertifikasiRplMataUji[k].idMasterMataUji);
            form.append('sertifikasiRplMataUjiRequest['+k+'].deskripsi', formData.sertifikasiRplMataUji[k].deskripsi);
            form.append('sertifikasiRplMataUjiRequest['+k+'].batasNilai', formData.sertifikasiRplMataUji[k].nilaiMinimum);
            form.append('sertifikasiRplMataUjiRequest['+k+'].idSertifikasiRplMataUji', formData.sertifikasiRplMataUji[k].idSertifikasiRplMataUji);
        }
        form.append("kategori", formData.kategori);
        form.append("biayaPerMataUji", "0");
        form.append("status", formData.status);
        return axios
            .put(
                API_URL + putRplWorkshop + formData.idSertifikasiRpl, form,
                { headers: { 'Content-Type': 'multipart/form-data','Authorization' : tokenHeader() } }
            );
    }

    deleteDokumen(value) {
        return axios
        .delete(
            API_URL + deleteDokumen + value.id_dokumen_pendukung_sertifikasi_rpl,
            { headers: authHeader() }
        );
    }

    deleteInstruktur(value) {
        return axios
        .delete(
            API_URL + deleteInstruktur + value.id_instruktur_sertifikasi_rpl,
            { headers: authHeader() }
        );
    }

    deleteMataUji(value) {
        return axios
            .delete(
                API_URL + deleteMataUji+ value.id_sertifikasi_rpl_mata_uji,
                { headers: authHeader() }
            );
    }

    deleteRplWorkshop(formData) {
        return axios
            .delete(
                API_URL + deleteRplWorkshop + formData,
                { headers: authHeader() }
            );
    }

}

export default new RplWorkshopService();
